const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEnhanced(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1580_6650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.0211 58.4152C51.0211 58.4152 65.3334 52.121 70.1525 50.1331C78.5237 46.6777 80.9128 52.5966 77.7769 54.3355C68.8075 59.3069 52.9569 68.8076 44.2736 73.6973C39.9189 76.1496 33.4835 76.6883 28.709 75.2876L24.8634 74.1618C22.909 73.5896 20.8543 73.14 18.8813 73.2254",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeWidth: 2.22934,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 59.975C3.51033 57.9017 6.73174 54.7732 8.42604 53.3427C20.7989 42.9131 31.797 52.0014 31.797 52.0014L46.3509 53.0046C48.9704 53.1866 51.0288 55.5683 51.0214 58.4144C51.0139 59.674 50.4083 60.6363 48.9964 60.7887C45.9347 61.1194 30.6414 61.9554 30.6414 61.9554",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeWidth: 2.22934,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3939 10.6318L49.6911 22.3545H56.3346L44.3667 38.3277L45.2176 26.2595L39.7334 26.2633L49.3939 10.6318Z",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeWidth: 2.22934,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5762 6.78287C38.1394 4.19312 42.5238 2.66602 47.2649 2.66602C59.1918 2.66602 68.8635 12.3339 68.8635 24.2646C68.8635 29.7897 66.7865 34.8317 63.3719 38.6551",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeWidth: 2.22934,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.977 43.0217C54.8188 44.8275 51.1626 45.8604 47.265 45.8604C35.338 45.8604 25.6664 36.1925 25.6664 24.2618C25.6664 19.5021 27.2046 15.1029 29.813 11.5322",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeWidth: 2.22934,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1580_6650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnhanced);
export default __webpack_public_path__ + "static/media/icon-enhanced.385aaff9e48658e04f95d8976f1e64d4.svg";
export { ForwardRef as ReactComponent };